<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="min-height: auto">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="addForm.institutionCode" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="名称" required prop="name">
                <el-input v-model="addForm.name" placeholder="输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="Imei号" required prop="imei">
                <el-input v-model="addForm.imei" placeholder="输入Imei号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="modal-footer">
        <el-button type="default" @click="closeSelf" style="margin-right: 10px">取消</el-button>
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>

    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5_with_china} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props:['arr_ins'],
  data() {
    return {
      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        plateform:'shop',
        phone:'',
        institutionCode:'',
        institutionName:'',

        name:'',
        imei:'',
      },
      rules:{
        imei:[
          { required: true, message: '输入imei号', trigger: 'blur' },
        ],
        name:[
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        institutionCode:[
          { required: true, message: '请选择机构', trigger: 'blur' }
        ]
      }
    }
  },
  components:{

  },
  methods: {
    init(){
      this.$refs.addForm.resetFields();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }


      for(let i=0;i<this.arr_ins.length;i++){
        if(this.arr_ins[i].institutionCode == this.addForm.institutionCode){
          this.addForm.institutionName = this.arr_ins[i].userName;
          this.addForm.phone = this.arr_ins[i].userPhone;
        }
      }

      this.addForm.sign = "";
      this.addForm.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(this.addForm) + "&key="+this.$signKey)


      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"GroupNanXue/Add",
        data: this.addForm
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              //this.$message({type: 'success', message: '添加成功'});
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          })

    },


  }
}


</script>


